export default __webpack_public_path__ + "static/media/faceBotB.0790c4d8.png";